export default __webpack_public_path__ + "static/media/header-bg.278e578a.png";